import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "chevron-horizontal-12", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { id: "Web/Filled/12\\xD712/chevron.right", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { id: "Path-2", stroke: "currentColor", strokeWidth: 1.5, d: "M5 3l3 3-3 3" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
